"use client";

import React from "react";

import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Aidan Simpson (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1766))
 * @lastsynced 2023-02-14T01:15:34.626Z
 * @optimized using svgo:^3.0.2
 */
export const Add = createSVGIcon(
  <path
    d="M12 1.714v20.572M1.714 12h20.572"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Add",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      id: "pwqcHa",
      defaultMessage: "Add",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    className: iconCls(),
  })
);
